import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "react-feather";
import { GET } from "../../../api/adminApi";
import { getDateTime } from "../../../utils/Dates";

export default function NewsView() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    async function getData() {
      const response = await GET("/services/admin/api/news/" + id);
      if (response) {
        setData(response);
      }
    }
    if (id) {
      getData();
    }
  }, [id]);

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <div className="mb-2 mx-3">
      <div className="d-flex align-items-center mb-5 mt-5">
        <Link to="/admin/news" className="btn btn-icon btn-light-primary me-3">
          <ArrowLeft size={20} />
        </Link>
        <h3 className="m-0">Просмотр новости</h3>
      </div>

      <div className="admin-card py-4 px-5">
        <div className="row mb-5">
          {/* Left Column for Images */}
          <div className="col-md-4">
            {/* Main Photo */}
            <div className="mb-5">
              <label className="fw-bold fs-6 mb-2">Главное фото:</label>
              <div className="border rounded p-2" style={{ maxWidth: "300px" }}>
                {data.photo ? (
                  <img
                    src={
                      data.photo.startsWith("http")
                        ? data.photo
                        : "https://api-club.akfacomfort.uz" + data.photo
                    }
                    alt={data.title}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "5px",
                    }}
                  />
                ) : (
                  <span className="text-muted">Нет фото</span>
                )}
              </div>
            </div>

            {/* Thumbnail Photo */}
            <div>
              <label className="fw-bold fs-6 mb-2">Превью (Миниатюра):</label>
              <div className="border rounded p-2" style={{ maxWidth: "150px" }}>
                {data.thumbPhoto ? (
                  <img
                    src={
                      data.thumbPhoto.startsWith("http")
                        ? data.thumbPhoto
                        : "https://api-club.akfacomfort.uz" + data.thumbPhoto
                    }
                    alt={`${data.title} thumbnail`}
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "5px",
                    }}
                  />
                ) : (
                  <span className="text-muted">Нет превью</span>
                )}
              </div>
            </div>
          </div>

          {/* Right Column for Text Data */}
          <div className="col-md-8">
            <div className="mb-4">
              <label className="fw-bold fs-6 mb-2">Заголовок:</label>
              <div className="fs-5">{data.title}</div>
            </div>
            <div className="mb-4">
              <label className="fw-bold fs-6 mb-2">Текст:</label>
              <div
                className="fs-6 text-gray-700"
                style={{ whiteSpace: "pre-wrap" }}
              >
                {data.text}
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-6 mb-4">
                <label className="fw-bold fs-6 mb-2">Опубликовано:</label>
                <div>
                  {data.published ? (
                    <span className="badge badge-success">Да</span>
                  ) : (
                    <span className="badge badge-danger">Нет</span>
                  )}
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <label className="fw-bold fs-6 mb-2">Дата создания:</label>
                <div>{getDateTime(data.createdTime)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
